import {
    getMsalInstance,
    IS_LOGIN_NOT_REQUIRED,
    loginRedirectPreservingLocation,
    markAuthBootstrapComplete,
} from './auth';

let localVersion;
function loadApp() { }
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms)); // eslint-disable-line
}
function checkVersion() {
    const headers = new Headers();
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache, no-store');

    fetch('/version.json', { cache: 'no-cache', redirect: 'follow', headers })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            return Promise.reject(new Error('Failed to fatch Version'));
        })
        .then((versionObj) => {
            const version = versionObj.releaseVersion;
            if (!localVersion) {
                localVersion = version;
            } else if (version !== localVersion) {
                // TODO: use existing styled Banner to show this
                // eslint-disable-next-line no-alert
                const r = window.confirm(`A new version ${version} is found, click OK to refresh now or cancel to reload the page later`);
                if (r === true) {
                    window.location.reload();
                }
                return true;
            }
            return false;
        })
        .then((stopChecking) => {
            if (!stopChecking) {
                sleep(1000 * 60).then(checkVersion);
            }
        })
        .catch(() => sleep(1000 * 60).then(checkVersion));
}

// Detects an OAuth response carried in the URL (search or hash). MSAL consumes
// it inside handleRedirectPromise, so we have to capture the signal *before*
// that call. When the user lands on the redirectUri (the root) after AAD,
// MSAL's handleRedirectPromise initiates a navigation back to the original
// deep link and resolves with null. Without this signal we'd interpret the
// null + missing account as "needs login" and call loginRedirect again,
// racing MSAL's navigation and bouncing the user back to AAD with the root
// captured as the new origin URL (ending up at '/' instead of the deep link).
function urlHasAuthResponse() {
    const { search, hash } = window.location;
    return /[?&#](code|error|state)=/.test(search) || /[?&#](code|error|state)=/.test(hash);
}

async function checkAuthentication() {
    if (IS_LOGIN_NOT_REQUIRED) {
        markAuthBootstrapComplete();
        loadApp();
        return;
    }

    const msalInstance = getMsalInstance();
    await msalInstance.initialize();

    const wasReturningFromAad = urlHasAuthResponse();

    let response = null;
    try {
        response = await msalInstance.handleRedirectPromise();
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }

    if (response && response.account) {
        msalInstance.setActiveAccount(response.account);
        markAuthBootstrapComplete();
        loadApp();
        return;
    }

    if (wasReturningFromAad) {
        // MSAL is navigating the browser back to the original deep link.
        // The page is about to reload — leave the bootstrap latch unresolved
        // so any in-flight authed fetches stay parked until the next page.
        return;
    }

    const account = msalInstance.getAllAccounts()[0];
    if (account) {
        msalInstance.setActiveAccount(account);
        markAuthBootstrapComplete();
        loadApp();
    } else {
        // Same as the wasReturningFromAad branch: the page is about to leave
        // for AAD, so don't resolve the latch and don't let queued fetches
        // surface "No user account found" errors right before navigation.
        loginRedirectPreservingLocation('bootstrap');
    }
}

checkVersion();
checkAuthentication();
